<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="
        chk_relation_type_editable('/article_category/data')
          ? fromParentBtn
          : ''
      "
      :btnClass="'btn-primary'"
      :btnToLink="
        chk_relation_type_editable('/article_category/data')
          ? '/article_category/add'
          : ''
      "
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div
      class="w100"
      v-if="
        typeof region_list === 'object' && Object.keys(region_list).length > 0
      "
    >
      <table class="table">
        <thead>
          <tr>
            <th style="width: 40%">カテゴリ名</th>
            <th style="width: 10%">ソートNo</th>
            <th colspan="2" style="width: 15%">action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in region_list" :key="list.id">
            <td>{{ list.label }}</td>
            <td>{{ list.sort }}</td>
            <td>
              <bs-button
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="handleClick(list.id)"
                >詳細</bs-button
              >
            </td>
            <td>
              <bs-button
                v-if="chk_relation_type_editable('/article_category/data')"
                :btnClass="'btn-danger btn-sm'"
                @to_click_event="delData(list.id)"
                >削除</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
// import Common from '../common/common'
import BsButton from '../../atoms/BsButton.vue'
import config from '../../../const'

export default {
  name: 'ArticleCategoryListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '商品カテゴリマスタ一覧',
      fromParentBtn: 'データ登録',
      region_obj: []
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert
  },
  computed: {
    ...mapState({}),
    region_list: function () {
      const lists = [...this.region_obj]
      return lists.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    }
  },

  async created() {
    await this.loadRegionList()
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = '商品カテゴリです。'
  },

  methods: {
    async delData(target) {
      if (confirm('削除しますか？')) {
        const data = this.region_obj.find(region => {
          return region.id == target
        })
        // console.log('ret ticket data' ,ticket);
        data['stat'] = 9
        return this.$store
          .dispatch('updateBasic', { data: data, target: 'article_category' })
          .then(() => {
            this.alertMessage = '削除しました'
            this.alertClass = 'alert-success'
          })
          .catch(err => {
            // Promise.reject(err)
            console.log(err)
            this.alertMessage = '削除できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(async () => {
            await this.loadRegionList()
          })
      }
    },
    async loadRegionList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/article_category/lists',
        params
      )
        .then(async response => {
          console.log('loadCateList response', response)
          this.region_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.region_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    handleClick(target) {
      this.$router.push({ path: '/article_category/' + target + '/' })
    }
  }
}
</script>
